// Generated by CoffeeScript 2.7.0
var Edge, MIN_OFFSET;

import Ajax from 'libs/ajax.js';

import UserBoundary from '../user_boundary.js';

import BaseModel from '../base_model.js';

import Vertex from './vertex.js';

import Condition from './condition.js';

MIN_OFFSET = 10;

export default Edge = (function() {
  class Edge extends BaseModel {
    static new(edge, graph) {
      if (edge instanceof this) {
        if (graph) {
          edge.graph = graph;
        }
        return edge;
      } else {
        return new this(edge, graph);
      }
    }

    constructor(attrs, graph) {
      super(attrs);
      this.metadata = _.extend({}, {
        connection_direction: {
          from: 1,
          to: 1
        }
      }, attrs.metadata);
      this.graph = graph;
      _.each(['from', 'to'], (key) => {
        if (_.has(attrs, key)) {
          return this[key] = Vertex.new(attrs[key]);
        }
      });
      this._makeConditions(attrs.conditions);
    }

    setStatus(status) {
      return this._status = status;
    }

    updateUserBoundaryCondition(ub) {
      return this.userBoundaryCondition.user_boundary.update(ub);
    }

    update() {
      if (!(this.isPersisted() && this.graph)) {
        return false;
      }
      return Ajax.patch(`/admin${this.graph.gid.toPath()}/edges/${this.id}`, {
        data: {
          edge: this.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data) => {
          return this._makeConditions(data.conditions);
        }
      });
    }

    enableDelete() {
      this.errors.clear();
      if (!(this.isPersisted() && this.graph)) {
        this.errors.add('edge', '未保存的边删除无效');
      }
      if (!this.errors.isBlank()) {
        return false;
      }
      return true;
    }

    delete() {
      if (!this.enableDelete()) {
        return;
      }
      return Ajax.delete(`/admin${this.graph.gid.toPath()}/edges/${this.id}`, {
        success: () => {
          return this.deleteSucceeded();
        }
      });
    }

    deleteSucceeded() {
      return this.graph.deleteEdge(this);
    }

    toJSON() {
      var edge, ub_condition_attributes;
      edge = super.toJSON();
      edge.from_vertex_id = this.from.id;
      edge.to_vertex_id = this.to.id;
      edge.conditions_attributes = _.chain(this.conditions).map(function(condition) {
        return condition.toJSON();
      }).compact().value();
      if (ub_condition_attributes = this.userBoundaryCondition.toJSON()) {
        edge.conditions_attributes.push(ub_condition_attributes);
      }
      return _.omit(edge, 'from', 'to', 'graph', '_status', 'conditions');
    }

    parseToPolylinePoints(width, height, buffer_width) {
      var dir, from_dir, from_position, from_positions, middle_x, middle_y, results, to_dir, to_position, to_positions;
      from_dir = this.metadata.connection_direction.from;
      to_dir = this.metadata.connection_direction.to;
      from_position = this.from.isFinal ? this.from.graph.metadata.position : this.from.metadata.position;
      to_position = this.to.isInitial ? this.to.graph.metadata.position : this.to.metadata.position;
      from_positions = this._getPositions(from_position, from_dir, width, height, buffer_width);
      to_positions = this._getPositions(to_position, to_dir, width, height, buffer_width);
      results = [];
      results.push(from_positions.origin);
      results.push(from_positions.offset);
      middle_x = (from_positions.offset[0] + to_positions.offset[0]) / 2;
      middle_y = (from_positions.offset[1] + to_positions.offset[1]) / 2;
      // 水平方向出
      if (Math.abs(from_dir) === 2) {
        // dir 为可能的转向
        if (to_positions.offset[1] < from_positions.offset[1]) {
          dir = 1;
        } else {
          dir = -1;
        }
        if (from_dir * (to_positions.offset[0] - from_positions.offset[0]) > 0) {
          if ((dir === (-1 * to_dir)) || (from_dir === to_dir)) {
            results.push([to_positions.offset[0], from_positions.offset[1]]);
          } else {
            results.push([middle_x, from_positions.offset[1]]);
            results.push([middle_x, to_positions.offset[1]]);
          }
        } else {
          if ((dir === to_dir) || (from_dir === to_dir)) {
            results.push([from_positions.offset[0], to_positions.offset[1]]);
          } else {
            results.push([from_positions.offset[0], middle_y]);
            results.push([to_positions.offset[0], middle_y]);
          }
        }
      } else {
        if (to_positions.offset[0] < from_positions.offset[0]) {
          dir = -2;
        } else {
          dir = 2;
        }
        if (from_dir * (to_positions.offset[1] - from_positions.offset[1]) > 0) {
          if ((dir === to_dir) || (from_dir === to_dir)) {
            results.push([to_positions.offset[0], from_positions.offset[1]]);
          } else {
            results.push([middle_x, from_positions.offset[1]]);
            results.push([middle_x, to_positions.offset[1]]);
          }
        } else {
          if ((dir === (-1 * to_dir)) || (from_dir === to_dir)) {
            results.push([from_positions.offset[0], to_positions.offset[1]]);
          } else {
            results.push([from_positions.offset[0], middle_y]);
            results.push([to_positions.offset[0], middle_y]);
          }
        }
      }
      results.push(to_positions.offset);
      results.push(to_positions.origin);
      return this._mergePathPoints(results);
    }

    _getPositions(position, dir, width, height, buffer_width) {
      var positions;
      return positions = (function() {
        switch (dir) {
          case 1:
            return {
              origin: [position.x + width / 2, position.y - buffer_width],
              offset: [position.x + width / 2, position.y - buffer_width - MIN_OFFSET]
            };
          case -1:
            return {
              origin: [position.x + width / 2, position.y + height + buffer_width],
              offset: [position.x + width / 2, position.y + height + buffer_width + MIN_OFFSET]
            };
          case 2:
            return {
              origin: [position.x + width + buffer_width, position.y + height / 2],
              offset: [position.x + width + buffer_width + MIN_OFFSET, position.y + height / 2]
            };
          case -2:
            return {
              origin: [position.x - buffer_width, position.y + height / 2],
              offset: [position.x - buffer_width - MIN_OFFSET, position.y + height / 2]
            };
        }
      })();
    }

    _mergePathPoints(points) {
      var current, next, prev, result, unvisited;
      if (points.length < 3) {
        return points;
      }
      result = points.slice(0, 2);
      unvisited = points.slice(2);
      prev = result[0];
      current = result[1];
      while (unvisited.length) {
        next = unvisited.shift();
        // 向量判同向: (x2-x1)*(y3-y2) = (x3-x2)*(y2-y1)
        if ((next[0] - current[0]) * (current[1] - prev[1]) === (next[1] - current[1]) * (current[0] - prev[0])) {
          result[result.length - 1] = next;
        } else {
          result.push(next);
          prev = current;
        }
        current = next;
      }
      return result;
    }

    _makeConditions(conditions) {
      var group_conditions;
      group_conditions = _.chain(conditions).map((condition) => {
        return new Condition(condition, this);
      }).groupBy(function(condition) {
        if (condition.isUserBoundaryCondition()) {
          return 'user_boundary';
        } else {
          return 'field_condition';
        }
      }).value();
      this.conditions = group_conditions.field_condition || [];
      return this.userBoundaryCondition = group_conditions.user_boundary && group_conditions.user_boundary.length ? group_conditions.user_boundary[0] : new Condition({
        user_boundary: {},
        conditionable_type: 'UserBoundary'
      }, this);
    }

  };

  // connection_direction 表示的是边从起始（结束）点的出去（进入）方向
  // -1 为下方， 1为上方，2为右边，-2为左边，数字值是为便于计算，确保 负下 和 上 为一个意思
  Edge.setAttributes([
    {
      _status: 'normal'
    },
    'from_vertex_id',
    'to_vertex_id',
    'from',
    'to',
    {
      conditions: [],
      metadata: {
        connection_direction: {
          from: 1,
          to: 1
        }
      }
    },
    'graph_id',
    'graph'
  ]);

  return Edge;

}).call(this);
